import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { SupplierInventoryRequest } from "@/main/models/request";
import { SupplierInventoryGridHistoryResponse, SupplierInventoryResponse } from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class ISupplierInventoryHistoryApi {
	abstract getHistoryInventory(
		request: SupplierInventoryRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierInventoryGridHistoryResponse>>>;

	abstract getHistoryDetail(
		request: SupplierInventoryRequest,
	): Promise<AxiosResponse<Result<SupplierInventoryResponse>>>;

	abstract getImportDetail(
		request: SupplierInventoryRequest,
	): Promise<AxiosResponse<Result<SupplierInventoryResponse>>>;
}
